import React from 'react';

type AgentGroupType = 'all' | 'registered' | 'none';

type OptionType = {
  title: string;
  subtitle: string;
  value: AgentGroupType;
  dataCY:
    | 'offer-notify-all'
    | 'offer-notify-registered'
    | 'offer-notify-la-only';
  hidden?: boolean;
};

const OPTIONS: OptionType[] = [
  {
    title: 'Auto Notify All Showing Agents',
    subtitle: 'All Showing Agents will be instantly notified',
    dataCY: 'offer-notify-all',
    value: 'all',
  },
  // This option is deprecated and will only show to offers that already have it selected
  {
    title: 'Notify Agents with Registered Offers ONLY',
    subtitle: 'Listing Agent will decide when to notify others',
    dataCY: 'offer-notify-registered',
    value: 'registered',
    hidden: true,
  },
  {
    title: 'Notify Listing Agents ONLY',
    subtitle: 'Listing Agent will decide when to notify others',
    dataCY: 'offer-notify-la-only',
    value: 'none',
  },
];

interface NotificationGroupProps {
  checked: string;
  onNotificationChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const NotificationGroup = ({
  checked,
  onNotificationChange,
}: NotificationGroupProps) => {
  const [showRegistered] = React.useState(checked === 'registered');

  const optionsFilter = ({ value }: { value: AgentGroupType }) => {
    if (showRegistered) return true;
    return value !== 'registered';
  };

  return (
    <div className="offer-settings-offer-notification-notification-group">
      <p>
        This setting will determine who will be notified when an offer is
        registered:
      </p>
      <div>
        {OPTIONS.filter(optionsFilter).map(
          ({ title, subtitle, dataCY, value }, i) => (
              <div
                key={i}
                className="offer-settings-offer-notification-notification-group-list-item"
              >
                <input
                  onChange={onNotificationChange}
                  checked={checked === value}
                  type="radio"
                  name="notification"
                  value={value}
                  data-cy={dataCY}
                />
                <label>{title}</label>
                <small>({subtitle})</small>
              </div>
            ),
        )}
      </div>
    </div>
  );
};

export default NotificationGroup;
